import script from "./DetalhesOrdemCompraEnxuto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesOrdemCompraEnxuto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesOrdemCompraEnxuto.vue?vue&type=style&index=0&id=1a80a44e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a80a44e"]])

export default __exports__